import { render, staticRenderFns } from "./ModifyPasswd.vue?vue&type=template&id=0aad6764&scoped=true"
import script from "./ModifyPasswd.vue?vue&type=script&lang=js"
export * from "./ModifyPasswd.vue?vue&type=script&lang=js"
import style0 from "./ModifyPasswd.vue?vue&type=style&index=0&id=0aad6764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aad6764",
  null
  
)

export default component.exports